import { Locales } from "@/enums/enums";
import { i18n } from "@/i18n";
import { RevenueDeductModel } from "@/model/revenueDeduct/revenueDeductModel";

export function ConvertToRevenueDeductList(revenueDeductRawList: any): Array<RevenueDeductModel> {
  const revenueDeductList: Array<RevenueDeductModel> = [];
  if (revenueDeductRawList && revenueDeductRawList.length > 0) {
    for (const revenueDeductRaw of revenueDeductRawList) {
      const revenueDeduct: RevenueDeductModel = {
        id: revenueDeductRaw.id,
        code: revenueDeductRaw.code,
        nameTh: revenueDeductRaw.nameTh,
        nameEn: revenueDeductRaw.nameEn,
        nameLocale: i18n.locale == Locales.TH ? revenueDeductRaw.nameTh : revenueDeductRaw.nameEn,
        accountId: revenueDeductRaw.accountId,
        type: revenueDeductRaw.type,
        isMain: revenueDeductRaw.isMain,
        isArchived: revenueDeductRaw.isArchived,
        revenueDeductType: revenueDeductRaw.revenueDeductType,
        taxRevenueCalculationType: revenueDeductRaw.taxRevenueCalculationType,
        socialSecurityRevenueCalculationType: revenueDeductRaw.socialSecurityRevenueCalculationType,
        isRegular: revenueDeductRaw.isRegular,
      };
      revenueDeductList.push(revenueDeduct);
    }
  }
  return revenueDeductList;
}
